import { Stack, Typography } from '@mui/material'

/** The read-only card: what was asked, and what the user answered. */
export default function ClarificationSubmittedView({ questions, answers }) {
  return (
    <Stack sx={{ gap: 0.75 }}>
      {questions.map((question) => (
        <Stack key={question.id} sx={{ gap: 0.125 }}>
          <Typography sx={{ fontSize: 12, color: 'var(--app-text-secondary)' }}>
            {question.question}
          </Typography>
          <Typography sx={{ fontSize: 13 }}>{answers?.[question.id] || '—'}</Typography>
        </Stack>
      ))}
    </Stack>
  )
}
